/* unplugin-vue-components disabled */import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  id: "uploadedImagesDrawer",
  class: "mt-8 h-full"
};
const _hoisted_2 = {
  class: "py-4 text-white"
};
import useNodeClient from '@/composables/services/useNodeClient';
import { useConfiguratorStore } from '@/stores/configurator';
import { useImagesStore } from '@/stores/images';
import { useCreateEditorImage } from '@/composables/2dEditor/useCreateEditorImage';
import UploadedImagesGrid from '@/components/common/UploadedImagesGrid';
import UploadImageWrapper from '@/components/configurator/sidebar/drawer/UploadImageWrapper';

// import { deleteImage } from '@/services/images'

export default {
  __name: 'UploadedImagesToolbar',
  setup(__props) {
    // import Adapter from '@/services/adapter'
    const Adapter = useNodeClient();
    const imagesStore = useImagesStore();
    const {
      images,
      TOTAL_COUNT
    } = storeToRefs(imagesStore);
    const {
      addImages,
      addUploadedImages,
      removeImageById
    } = imagesStore;
    const configuratorStore = useConfiguratorStore();
    const $eventBus = inject('bus');
    const {
      closeDrawer
    } = configuratorStore;
    // const { checkedDrawer } = storeToRefs(configuratorStore)
    // Pagination
    const skip = ref(0);
    const limit = ref(10);
    const CURRENT_PAGE = ref(1);

    /**
     * Fetches and processes images for display with pagination.
     */
    const fetchImages = async (skipValue, limitValue) => {
      try {
        // // console.log('TOKEN IMAGES:', token)
        const {
          data,
          page,
          total_count
        } = await Adapter.getImages(limitValue, skipValue);

        // @TODO: quick fix - Don't update images
        if (CURRENT_PAGE.value === page && images.value.length) {
          return;
        }
        addImages(data);
        CURRENT_PAGE.value = page;
        TOTAL_COUNT.value = total_count;
      } catch (error) {
        console.error('[UploadedImagesToolbar] fetchImages error fetching images', error?.message || error);
      }
    };
    const onDeleteImage = async id => {
      try {
        // Check if image is used in the editor
        // Check if image is used in other configuration
        //  Show modal if true

        await Adapter.deleteImage(id).then(() => {
          removeImageById(id);
          TOTAL_COUNT.value -= 1;
        }).catch(error => {
          throw new Error(error);
        });
      } catch (error) {
        console.error('[UploadedImagesToolbar] handleDeleteImage error deleting image', error?.message || error);
      }
    };
    const initializeThumbnailImages = async () => {
      await fetchImages(skip.value, limit.value);
    };
    onMounted(async () => {
      try {
        await initializeThumbnailImages();
      } catch (error) {
        console.error('Failed to fetch images:', error);
      }
    });
    async function onHandleImage(image) {
      if (image) {
        const originalUrl = image?.url;
        const id = image?._id;
        const url = image?.versions?.find(({
          version
        }) => version === 'medium')?.url || originalUrl;
        if (url) {
          const payload = {
            src: url,
            id,
            originalSource: originalUrl
          };
          const obj = await useCreateEditorImage(payload);
          $eventBus.$emit('object-added-new', obj);
          closeDrawer();
        }
      }
    }
    async function onUploadedImages(files) {
      addUploadedImages(files);
    }
    /**
     * Loads more images and updates the pagination state.
     */
    async function onClickLoadMoreImages() {
      skip.value += limit.value;
      await fetchImages(skip.value, limit.value);
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(UploadImageWrapper), {
        onUploadedImages: onUploadedImages,
        onHandleImage: onHandleImage
      }, {
        default: _withCtx(() => [_createVNode(_unref(UploadedImagesGrid), {
          images: _unref(images),
          onHandleImage: onHandleImage,
          onDeleteImage: onDeleteImage
        }, null, 8, ["images"]), _createElementVNode("div", _hoisted_2, [_unref(images).length && _unref(images).length < _unref(TOTAL_COUNT) ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "load-more-btn",
          onClick: _withModifiers(onClickLoadMoreImages, ["stop"])
        }, _toDisplayString(_ctx.$t('gallery.loadMoreImages')), 1)) : _createCommentVNode("", true)])]),
        _: 1
      })]);
    };
  }
};